import React, { useState } from 'react';
import axios from 'axios';
import { Table, Button, Form, Alert, Spinner } from 'react-bootstrap';
import BASE_URL from '../config'; // Import your BASE_URL

const SearchEmail = () => {
  const [email, setEmail] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter an email address');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');
    
    try {
      const response = await axios.get(`${BASE_URL}api/proxy/search-email`, {
        params: { email }

      });
      
      if (response.data.results) {
        setResults(response.data.results);
        setSuccess(`Found ${response.data.results.length} results`);
      } else {
        setResults([]);
        setSuccess(response.data.message || 'No results found');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to search email');
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (database, table) => {
    try {

      const response = await axios.get(`${BASE_URL}api/proxy/download-email-data`, {
        params: { email, database, table },
        responseType: 'blob'
      });
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Extract filename from content-disposition or create one
      const contentDisposition = response.headers['content-disposition'];
      let filename = `${database}_${table}_data.csv`;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }
      
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      setError('Failed to download data: ' + (err.response?.data?.error || err.message));
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-lg">
        <div className="card-body">
          <h2 className="text-center mb-4">Search Email in Databases</h2>
          
          <Form onSubmit={handleSearch} className="mb-4">
            <Form.Group controlId="emailSearch" className="mb-3" style={{ maxWidth: '400px' }}>
              <Form.Label>Enter Email Address:</Form.Label>
              <div className="d-flex">
                <Form.Control
                  type="email"
                  placeholder="Enter email to search"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <Button variant="primary" type="submit" className="ms-2" disabled={loading}>
                  {loading ? <Spinner animation="border" size="sm" /> : 'Search'}
                </Button>
              </div>
            </Form.Group>
          </Form>

          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="success">{success}</Alert>}

          {results.length > 0 && (
            <div className="mt-4">
              <h4>Search Results</h4>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>Database</th>
                    <th>Table</th>
                    <th>Download</th>
                  </tr>
                </thead>
                <tbody>
                  {results.map((result, index) => (
                    <tr key={index}>
                      <td>{result.database}</td>
                      <td>{result.table}</td>
                      <td>
                        <Button 
                          variant="success" 
                          size="sm"
                          onClick={() => handleDownload(result.database, result.table)}
                        >
                          Download
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchEmail;